const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Secure Vault',
    description: 'Bank-grade encryption protects your intellectual property. Your designs, specifications, and proprietary data remain confidential with enterprise-level security protocols.',
    gradient: 'from-orange-500 to-red-500'
  },
  {
    icon: 'ri-archive-line',
    title: 'Project Archive',
    description: 'Access all your historical projects instantly. Every file, render, and conversation from the past 2+ years is searchable and downloadable whenever you need it.',
    gradient: 'from-red-500 to-amber-500'
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Priority Queue',
    description: 'Portal submissions bypass the email queue entirely. Your projects receive immediate attention from our engineering team, ensuring faster turnaround times.',
    gradient: 'from-amber-500 to-orange-500'
  }
];

export default function FeatureGrid() {
  return (
    <section className="relative py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Additional Info Banner */}
        <div className="mt-20 relative rounded-2xl border border-orange-500/20 bg-gradient-to-r from-orange-500/5 to-red-500/5 backdrop-blur-xl p-12 overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `linear-gradient(rgba(249,115,22,0.1) 1px, transparent 1px),
                               linear-gradient(90deg, rgba(249,115,22,0.1) 1px, transparent 1px)`,
              backgroundSize: '30px 30px'
            }}></div>
          </div>
          
          <div className="relative z-10 text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <i className="ri-information-line text-3xl text-orange-500"></i>
              <h3 className="text-3xl font-bold">Complimentary for All Partners</h3>
            </div>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              This portal is our commitment to streamlining collaboration. There are no additional fees, subscriptions, or hidden costs. 
              It's simply a better way to work together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}